import { ThreeCircles } from "react-loader-spinner"
import "./Loader.css"

export const Loader=()=>{
    return (
        <div className="loader">
             <ThreeCircles color="#4788c9" />
        </div>
    )
}